import { CSSProperties } from "react";
import Button from "react-bootstrap/Button";
import Spinner from "react-bootstrap/Spinner";

import styles from "./button-with-spinner.less";

type ButtonWithSpinnerProps = {
    id?: string;
    style?: CSSProperties;
    type: "button" | "submit" | "reset";
    disabled: boolean;
    label: string;
    buttonSize?: "sm" | "lg";
    hideSpinner?: boolean;
    className?: string;
    automationId?: string;
    onClick?: () => void;
};

export const ButtonWithSpinner = (props: ButtonWithSpinnerProps) => {
    const {
        id,
        style,
        className,
        type,
        disabled,
        label,
        hideSpinner,
        automationId,
        buttonSize,
        onClick
    } = props;

    return (
        <Button
            id={id}
            style={style}
            automation-id={automationId}
            size={buttonSize}
            type={type}
            disabled={disabled}
            className={className}
            onClick={onClick}
        >
            {label}
            <Spinner
                className={styles.spinner}
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
                hidden={!disabled || hideSpinner}
            />
        </Button>
    );
};